(ns frontend.view.modals.curtains.tenant-custom-filter-curtain.events)

(defn validate! [filter-state button-state]
  (let [{:keys [selected-association-types selected-countries selected-cities]} @filter-state
        valid? (and selected-association-types selected-countries)]
    (reset! button-state (boolean valid?))
    (deref button-state)
    valid?))

(defn reset-state [filter-state button-state init-state]
  (reset! filter-state init-state)
  (validate! filter-state button-state))

